import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { bonuses, type Bonus } from '../data/bonuses';
import { accentBg, accentText } from '../utils/accent';
import { BONUS_SIZES, BONUS_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function BonusesSection() {
  return <section id="bonos" className="defer-paint w-full scroll-mt-6 bg-paper-soft py-14 sm:py-20" aria-labelledby="bonuses-heading" data-id="element-13" data-mp="qsi1ajvy5bfk">
      <div className="mx-auto max-w-5xl px-6" data-id="element-14" data-mp="zuhjvgmm0nkm">
        <SectionHeading eyebrow="Inclusi gratis" eyebrowTone="rust" title={<span id="bonuses-heading" data-id="element-16" data-mp="1ejx9uuebgoz9">+ 5 bonus operativi</span>} lead="Strumenti pratici e semplici da consultare per risolvere situazioni reali durante la preparazione e sul campo." data-id="element-15" data-mp="ztq1j7i0wmca" />

        <ul className="mt-12 space-y-5" data-id="element-17" data-mp="1nk26qalvw4z6">
          {bonuses.map(bonus => <li key={bonus.number} className="grid overflow-hidden rounded-2xl border border-line bg-paper sm:grid-cols-[240px_1fr] lg:grid-cols-[300px_1fr]" data-id="element-18" data-mp="1nkbx3zauce5e">
              <div className="relative" data-id="element-19" data-mp="3pr3n6i2gympa">
                <img src={optimizedImage(bonus.image, 480)} srcSet={optimizedSrcSet(bonus.image, BONUS_WIDTHS)} sizes={BONUS_SIZES} alt={bonus.alt} className="aspect-[16/9] h-full w-full object-cover sm:aspect-auto" width={1200} height={900} loading="lazy" decoding="async" {...{
              fetchpriority: 'low'
            }} data-id="element-20" data-mp="3ps4xulfkp76h" />
                <span className={`absolute inset-x-0 bottom-0 h-2 ${accentBg[bonus.accent]}`} aria-hidden="true" data-id="element-21" data-mp="cjs81ltl7mqf" />
              </div>

              <div className="p-5 sm:p-7" data-id="element-22" data-mp="gkc22giv6a8c">
                <div className="flex items-center gap-2.5" data-id="element-23" data-mp="gj0xiehlgyg6">
                  <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-ink-muted" data-id="element-24" data-mp="ldexyvb45vrp">
                    Bonus {bonus.number}
                  </p>
                  <span className="rounded-md bg-ember px-2 py-0.5 font-display text-xs font-semibold uppercase tracking-[0.12em] text-paper-soft" data-id="element-25" data-mp="vataijtx20eq">
                    Gratis
                  </span>
                </div>

                <h3 className={`mt-2 font-display text-2xl font-bold uppercase leading-tight sm:text-3xl ${accentText[bonus.accent]}`} data-id="element-26" data-mp="am0k6dq4g36p">
                  {bonus.title}
                </h3>
                <p className="mt-3 font-sans text-base leading-relaxed text-ink-muted" data-id="element-27" data-mp="kc3m53f80rh6">
                  {bonus.intro}
                </p>

                <BonusItems bonus={bonus} data-id="element-28" data-mp="fi8t39dq705f" />

                <div className="mt-4 space-y-1" data-id="element-29" data-mp="tb72w0qx0usi">
                  {bonus.outro.map((line, index) => <p key={line} className={index === 0 && bonus.outro.length > 1 ? 'font-sans text-sm leading-relaxed text-ink-muted' : 'font-sans text-sm font-semibold leading-relaxed text-ink'} data-id="element-30" data-mp="ocvuzvk6kucx" data-mpi={index}>
                      {line}
                    </p>)}
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}
function BonusItems({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.itemsStyle === 'quotes') {
    return <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-31" data-mp="303r700gymtjm">
        {bonus.items.map(item => <li key={item} className="rounded-lg border-l-4 border-olive bg-paper-deep px-3 py-2 font-display text-base font-medium text-ink" data-id="element-32" data-mp="1flglw2bwmtfa">
            “{item}”
          </li>)}
      </ul>;
  }
  return <ul className="mt-4 flex flex-wrap items-center gap-2" data-id="element-33" data-mp="15tj94r58zteg">
      {bonus.items.map((item, index) => <li key={item} className="flex items-center gap-2" data-id="element-34" data-mp="1asdthxiv5q0o" data-mpi={index}>
          <span className="whitespace-nowrap rounded-md bg-paper-deep px-3 py-1.5 font-display text-sm font-semibold uppercase tracking-[0.08em] text-ink" data-id="element-35" data-mp="wtw6y34p2jkc">
            {item}
          </span>
          {bonus.itemsStyle === 'flow' && index < bonus.items.length - 1 ? <ArrowRightIcon className={`h-4 w-4 ${accentText[bonus.accent]}`} strokeWidth={2.6} aria-hidden="true" data-id="element-36" data-mp="mx1dhyna39cx" /> : null}
        </li>)}
    </ul>;
}